import { type DocumentOCRResultForm } from './types'

export const DOCUMENT_OCR_RESULT_FORM_DEFAULT_VALUES: DocumentOCRResultForm = {
  caseNumber: {
    isNew: false,
    text: '',
    value: '',
  },
  applicantName: {
    isNew: false,
    text: '',
    value: '',
  },
  applicationFiledDate: {
    isNew: false,
    text: '',
    value: '',
  },
  applicantCandidateList: [],
  applicantNameCandidate: {
    ocrScannedApplicantNameWhenNew: '',
    ocrScannedApplicantNameWhenExisting: '',
    matchingApplicantId: undefined,
  },
  biometricDate: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  caseAdditionalData: {
    caseCategory: '',
    caseTags: [],
    caseId: 0,
    email: '',
    phone: '',
  },
  caseType: {
    isNew: false,
    text: '',
    value: '',
  },
  fileName: '',
  imgUrls: [],
  interviewDate: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  nationality: {
    isNew: false,
    text: '',
    value: '',
  },
  priorityDate: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  rfeDueDate: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  serviceCenter: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  validFrom: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  validTo: {
    isNew: false,
    text: undefined,
    value: undefined,
  },
  isReviewed: false,
  jobId: 0,
  taskId: 0,
  status: '',
}
